import React, { useCallback } from 'react';
// @ts-ignore
import { NotificationsList } from 'arag-ui-lib';
import messageProjections from '../../projections/message';
import * as actions from '../../actions';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';

const ApplicationMessages = () => {
    const dispatch = useAppDispatch();
    const removeMessageAction = useCallback(
        (payload: actions.removeMessageAction) =>
            dispatch(actions.removeMessage(payload)),
        [dispatch],
    );

    const handleMessageRemove = (message: { key: string }) => {
        removeMessageAction({
            uuid: message.key,
        });
    };
    const applicationMessageList = useAppSelector(
        messageProjections.applicationMessageList(handleMessageRemove),
    );
    return (
        <>
            {applicationMessageList && applicationMessageList.length > 0 ? (
                <NotificationsList
                    variant={'error'}
                    position={'topCenter'}
                    notifications={applicationMessageList}
                />
            ) : null}
        </>
    );
};

export default ApplicationMessages;
